import { parseStartDate, parseEndDate } from '../../../utils/parseDate';

export const getCompareDatesForOption = ({
    startDate,
    endDate,
    option,
}: {
    startDate: Date;
    endDate: Date;
    option?: string;
}) => {
    if (!option || !['previous_year', 'previous_days'].includes(option)) {
        return undefined;
    }

    const getPreviousYearDate = (date: Date): Date => {
        const newDate = new Date(date);
        newDate.setFullYear(newDate.getFullYear() - 1);
        return newDate;
    };

    const getPreviousDaysDate = (date: Date, dateDiff: number): Date => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() - dateDiff);
        return newDate;
    };

    const dateDiff = Math.round(
        (new Date(endDate).getTime() - new Date(startDate).getTime()) /
            (3600 * 1000 * 24),
    );

    const previousDates = {
        previous_year: {
            startDate: startDate
                ? parseStartDate(getPreviousYearDate(startDate))
                : null,
            endDate: endDate
                ? parseEndDate(getPreviousYearDate(endDate))
                : parseEndDate(getPreviousYearDate(new Date())),
        },
        previous_days: {
            startDate: !Number.isNaN(dateDiff)
                ? parseStartDate(getPreviousDaysDate(startDate, dateDiff))
                : null,
            endDate: !Number.isNaN(dateDiff)
                ? parseEndDate(getPreviousDaysDate(endDate, dateDiff))
                : parseEndDate(new Date()),
        },
    };

    return previousDates[option];
};

export const getSyncedCompareDates = ({
    startDate,
    endDate,
    compareDates,
}: {
    startDate: Date;
    endDate: Date;
    compareDates?: {
        option?: string;
        dates?: {
            startDate: string;
            endDate: string;
        };
    };
}) => {
    if (!compareDates?.option) {
        return null;
    }

    const dates = getCompareDatesForOption({
        startDate,
        endDate,
        option: compareDates.option,
    });

    if (!dates) {
        return null;
    }

    if (
        compareDates.dates?.startDate === dates.startDate &&
        compareDates.dates?.endDate === dates.endDate
    ) {
        return null;
    }

    return {
        option: compareDates.option,
        dates,
    };
};
